import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Timestamp from '../Timestamp';
import PollOption from './PollOption';
import s from './PollView.scss';
var PollView = /** @class */ (function (_super) {
    tslib_1.__extends(PollView, _super);
    function PollView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onVote = function (answerId) {
            var _a = _this.props, poll = _a.deviation.poll, onVote = _a.onVote;
            if (!poll) {
                return;
            }
            onVote({ pollId: poll.pollId, userId: poll.user.userId, answerId: answerId });
        };
        return _this;
    }
    PollView.prototype.render = function () {
        var _this = this;
        var _a = this.props, poll = _a.deviation.poll, canVote = _a.canVote, t = _a.t, className = _a.className;
        if (!poll) {
            return null;
        }
        return (React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement("div", { className: s['question'] }, poll.question),
            React.createElement("div", { className: s['info'] },
                React.createElement("span", { className: s['publication-date'] },
                    React.createElement(Timestamp, { timestamp: poll.ts })),
                React.createElement("span", { className: s['separator'] }, "|"),
                React.createElement("span", { className: s['votes'] }, t('pollView.votes', { count: poll.votes }))),
            poll.answers.map(function (answer) { return (React.createElement(PollOption, { className: s['poll-option'], answer: answer, canVote: canVote, onClick: _this.onVote, key: answer.answerId })); })));
    };
    return PollView;
}(React.Component));
export { PollView };
export default withTranslation()(PollView);
//# sourceMappingURL=PollView.js.map